/* eslint-disable @typescript-eslint/no-explicit-any */
import { IGeocodingAddress } from '../../model';
import { store } from '../../store';

const URL = 'https://maps.googleapis.com/maps/';

const reverse = (coords: [number, number]): Promise<any> => {
  const settings = store.getState().appSettings;
  const url = `${URL}api/geocode/json?latlng=${coords[1]},${coords[0]}&key=${settings.data?.map.google_api_token}&language=en`;
  return fetch(url).then((response) => response.json());
};

const getAddrComponent = (place: any, componentTemplate: any): string | null => {
  for (let i = 0; i < place.address_components.length; i++) {
    const addressType = place.address_components[i].types[0];
    if (componentTemplate[addressType]) {
      return place.address_components[i][componentTemplate[addressType]];
    }
  }

  return null;
};

const parseAddress = (place: any): IGeocodingAddress => {
  const components = place.address_components;

  const getComponent = (types: string[]) =>
      components ? components.find((c: any) => types.every(type => c.types.includes(type)))?.long_name || '' : '';

  const street = [getAddrComponent(place, { street_number: 'short_name' }), getAddrComponent(place, { route: 'long_name' })];

  const geo = parseGeometry(place);


  return {
    id: place.place_id,
    suite: getAddrComponent(place, { subpremise: 'short_name' }),
    city: getComponent ? getComponent(['locality']) || getComponent(['sublocality_level_1']) || getComponent(['postal_town']) : '',
    street: street.filter((x) => !!x).join(' '),
    state: getAddrComponent(place, { administrative_area_level_1: 'short_name' }),
    zip: getAddrComponent(place, { postal_code: 'long_name' }) || getAddrComponent(place, { postal_code_prefix: 'long_name' }),
    country: getAddrComponent(place, { country: 'short_name' }),
    lat: geo.lat,
    lng: geo.lng,
  };
};

const parseGeometry = (place: any): { lat: number | null; lng: number | null } => {
  const result = {
    lat: null,
    lng: null,
  };

  if (!place || !place.geometry || !place.geometry.location) {
    return result;
  }

  if (place.geometry.location.lat) {
    result.lat = typeof place.geometry.location.lat === 'function' ? place.geometry.location.lat() : place.geometry.location.lat;
  }

  if (place.geometry.location.lng) {
    result.lng = typeof place.geometry.location.lng === 'function' ? place.geometry.location.lng() : place.geometry.location.lng;
  }

  return result;
};

export const geocodingGoogleService = {
  reverse,
  parseAddress,
};
